import React from 'react';
import './css/Footer.css'
import logo from './img/logo-byn.png';
import logoFB from './img/icono_fb.png';
import logoIG from './img/icono_ig.png';
import logoTW from './img/icono_tw.png';

export default class Card extends React.Component {
  constructor(props) {
    super(props);
    this.state={}
  }

  render(){
    const {organismo, direccion, codPostal, telefonos, redesSociales} = this.props;
    const width = this.props.width === undefined ? 400 : this.props.width;
    return(
      <div className="FooterContainer">
        <div className="FooterInfo">
          <div style={{flex:3, display:'flex', flexDirection:'row', justifyContent:'center', padding:'auto'}}>
            <img
              src={logo}
              height={80}
              className="Logo"
              alt="Logo"
            />
          </div>
          <div style={{flex:5, display:'flex', flexDirection:'column', padding:'auto', justifyContent:'center'}}>
            <span>{organismo}</span>
            <span>{direccion}</span>
            <span>{codPostal}</span>
            {telefonos.map((item, index) =>{
              return(
                <span key={index}>Tel.: {item}</span>
              )
            })}
          </div>
          <div style={{flex:3, display:'flex', flexDirection:'row', justifyContent:'center', padding:'auto'}}>
            <a href={redesSociales.facebook} target="_blank" style={{margin:4}}>
              <img
                src={logoFB}
                height={40}
                className="Logo"
                alt="Logo"
              />
            </a>
            <a href={redesSociales.twitter} target="_blank" style={{margin:4}}>
              <img
                src={logoTW}
                height={40}
                className="Logo"
                alt="Logo"
              />
            </a>
            <a href={redesSociales.instagram} target="_blank" style={{margin:4}}>
              <img
                src={logoIG}
                height={40}
                className="Logo"
                alt="Logo"
              />
            </a>
          </div>
        </div>
        <div className="FooterLeyenda">
          <span>© 2022 GOBIERNO DE TIERRA DEL FUEGO A.E.I.A.S</span>
        </div>
      </div>
    )
  }
}
